var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AgItem',{attrs:{"rowData":_vm.soldReceivablesRowData,"columnDefs":_vm.soldReceivablesColumnDefs,"min-height":"164px","height-type":"matchRows"},on:{"sortChanged":_vm.sortChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }